import { Component, OnInit } from '@angular/core'
import { Company } from 'depoto-core/src/entities'
import { CoreService, NotificationService } from '../../services'
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms'
import { CheckDataChanges } from '../../services/can-deactivate-guard.service'
import { TranslateService } from '@ngx-translate/core'

import * as Sentry from '@sentry/angular-ivy'

@Component({
  selector: 'app-company-settings',
  templateUrl: 'company-settings.component.html',
})
export class CompanySettingsComponent implements OnInit, CheckDataChanges {
  company: Company
  loading = true
  submitted = false
  canStartPlugNPlayProcess = false
  initialEnabledPositionsState: boolean

  companySettingsForm = new FormGroup({
    phone: new FormControl<string | null>({ value: null, disabled: false }, []),
    email: new FormControl<string>({ value: null, disabled: false }, [Validators.required, Validators.email]),
    batchExpiration: new FormControl<string>({ value: null, disabled: false }, []),
    enabledPositions: new FormControl<string>({ value: null, disabled: false }, []),
    // enabledPositions: new FormControl<boolean>({ value: false, disabled: false }, []),
  })
  batchExpirationOptions: Array<{ name: string; code: string }> = [
    { name: this.translateService.instant('company.enabled-everywhere'), code: 'enabled-everywhere' },
    { name: this.translateService.instant('company.disabled-everywhere'), code: 'disabled-everywhere' },
    { name: this.translateService.instant('company.selected-products'), code: 'selected-products' },
  ]
  positionsOptions: Array<{ name: string; code: string }> = [
    { name: this.translateService.instant('company.positions-enabled'), code: 'enabled' },
    { name: this.translateService.instant('company.positions-disabled'), code: 'disabled' },
  ]
  pom = this.translateService.instant('company.enabled-everywhere')
  constructor(
    private core: CoreService,
    private notificationService: NotificationService,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {
    this.loading = true
    const company = this.core.services.storage.getSync(this.core.services.storage.keys.auth.company)
    if (company && company.id > 0) {
      this.company = company
      this.fillFormValue()
      this.canStartPlugNPlayProcess = this.core.services.user.hasRole('ROLE_USER_ADMIN_CREATE')
      this.initialEnabledPositionsState = company.enabledPositions
      this.loading = false
    }
  }

  hasUnsavedDataChanges(): boolean {
    return false
  }

  public fillFormValue() {
    this.companySettingsForm.setValue({
      phone: this.company.phone,
      email: this.company.email,
      batchExpiration: this.company.batchExpirationMode,
      enabledPositions: this.company.enabledPositions ? 'enabled' : 'disabled',
    })
  }

  public getFormValue() {
    this.company.phone = this.companySettingsForm.value.phone
    this.company.email = this.companySettingsForm.value.email
    this.company.batchExpirationMode = this.companySettingsForm.value.batchExpiration
    this.company.enabledPositions = this.companySettingsForm.value.enabledPositions === 'enabled'
  }

  async updateCompany() {
    this.submitted = true
    if (this.companySettingsForm.invalid) {
      return
    }
    if (this.initialEnabledPositionsState && this.companySettingsForm.value.enabledPositions === 'disabled') {
      if (!confirm(this.translateService.instant('company.enabledPositionsChange.warning'))) {
        return
      }
    }
    try {
      this.loading = true
      this.getFormValue()
      await this.core.services.company.update({
        id: this.company.id,
        phone: this.company.phone,
        email: this.company.email,
        batchExpirationMode: this.company.batchExpirationMode,
        enabledPositions: this.company.enabledPositions,
      })
      this.notificationService.success(this.translateService.instant('alert.company.updated'))
      this.core.services.storage.set(this.core.services.storage.keys.auth.company, this.company)
      if (this.core.services.user.user) {
        this.core.services.user.user.company = this.company
      }
      this.initialEnabledPositionsState = this.companySettingsForm.value.enabledPositions === 'enabled'
    } catch (err) {
      console.log(err)
    } finally {
      this.loading = false
    }
  }

  get formControls(): { [key: string]: AbstractControl } {
    return this.companySettingsForm.controls
  }
}
